import About from './about/about'
import SignupPanel from './signup/signup-panel'
import { Toaster } from 'react-hot-toast'
import * as env from '@/env'
import DevModeBanner from '@/components/dev-mode-banner'
import { useSessionContext } from '@/state/session-context'
import { Navigate } from 'react-router-dom'

function LoggedOut() {
	const { session } = useSessionContext()

	//	disable in production; will enable on launch
	// if (env.isProduction) {
	// 	return <div>Nothing to see here, please disperse.</div>
	// }

	if (session?.userId) {
		return <Navigate to="/chat" />
	}

	return (
		<div className="h-full w-full flex flex-col bg-[#FBFBF0]">
			{/* <DevModeBanner /> */}
			<div className="container mx-auto p-4 max-w-6xl overflow-y-auto">
				<div className="flex flex-col md:flex-row gap-4">
					<section className="flex-1 rounded-lg p-2">
						<About />
					</section>
					<div className="left-0 right-0 md:top-0 md:bottom-0 md:left-1/2 md:-translate-x-1/2">
						<div className="w-full h-px md:w-px md:h-full bg-gradient-to-r md:bg-gradient-to-b from-transparent via-gray-300 to-transparent"></div>
					</div>					
					<section className="flex-1 rounded-lg p-2">
						{/* <h2 className="text-2xl font-bold mb-4">Get Started</h2> */}
						<SignupPanel />
					</section>
				</div>
			</div>
			<Toaster />
		</div>
	)
}

export default LoggedOut
